import { render, staticRenderFns } from "./OrderData.vue?vue&type=template&id=0e9f4bae&scoped=true"
import script from "./OrderData.vue?vue&type=script&lang=js"
export * from "./OrderData.vue?vue&type=script&lang=js"
import style0 from "./OrderData.vue?vue&type=style&index=0&id=0e9f4bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9f4bae",
  null
  
)

export default component.exports